import { Box } from "@mui/material";
import React from "react";
import NextImage from "next/image";
import { decode } from "blurhash";
import PlaceholderImage from "@/assets/images/image_placeholder_light.jpg";

interface Props {
  src: string;
  width: number;
  height: number;
  alt: string;
}

export function Image(props: Props) {
  const ref = React.useRef<HTMLImageElement>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const element = ref.current;
    const handler = () => setIsLoading(false);
    if (element) element.addEventListener("load", handler);
    return () => element?.removeEventListener("load", handler);
  }, []);

  return (
    <Box width={props.width} height={props.height} overflow={"hidden"}>
      {isLoading ? (
        <Box
          sx={{
            borderRadius: "4px",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            position: "relative",
            opacity: 0.8,
            backgroundImage: `url(${PlaceholderImage.src})`,
            backgroundSize: "cover",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backdropFilter: "blur(16px)",
              transition: "all 0.3s ease",
            }}
          />
        </Box>
      ) : null}

      <Box
        ref={ref}
        component={"img"}
        src={props.src}
        alt={props.alt}
        sx={{
          width: "100%",
          height: "auto",
          objectFit: "contain",
        }}
      />
    </Box>
  );
}
